import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {getPublicApiUrl} from 'utils/apiUrls'

interface Ratings {
  ratingCount: number
  ratingScore: number
}

export interface AppRatings {
  android: Ratings
  ios: Ratings
}

const APP_SCRAPER_API_URL = `${getPublicApiUrl()}/app-scraper`

export const appRatingsApi = createApi({
  reducerPath: 'appRatingsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: APP_SCRAPER_API_URL
  }),
  endpoints: builder => ({
    getAppRatings: builder.query<AppRatings, void>({
      query: () => '/ratings'
    })
  })
})

export const {useGetAppRatingsQuery} = appRatingsApi
